import React from 'react';
import clsx from 'clsx';

import containerStyles from './container.module.scss';
import { Box } from '@/components/Box/Box';

type CollegialContainerProps = React.PropsWithChildren<{ className?: string }>;

export const CollegialContainer = ({ children, className }: CollegialContainerProps): JSX.Element => (
  <section className={clsx('hero', containerStyles.hero, className)}>
    <div className={clsx('grid hero-body', containerStyles['hero-body'])}>
      <Box paddingSize="none" className={clsx('container', containerStyles.container)} boxShadow>
        <div className={clsx('is-centered', containerStyles.inner)}>{children}</div>
        <div className={clsx('grid is-grey', containerStyles.footer)}>
          <div className="gc gc-12 gc-12-p gc-12-l">
            <div className={containerStyles.logo} />
          </div>
        </div>
      </Box>
    </div>
  </section>
);
